import { createContext } from 'react'
import type { Locale } from './types'

export type I18nContextValue = {
  language: Locale
  setLanguage: (locale: Locale) => void
  t: (key: string, params?: Record<string, string | number>) => string
  availableLocales: Array<{ code: Locale; label: string }>
}

export const I18nContext = createContext<I18nContextValue | undefined>(undefined)
